import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  chatActionButton: {
    width: 44,
    height: 44,
  },
  chatActionIcon: {
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}))

export default styles
